import { create } from "zustand";
import axiosInstance from "../api/axiosInstance";
import useAuthStore from "./useAuthStore";
import Base64e from "../components/encodedecode/encode";

interface SingleMatchState {
  match: any | null;
  loading: boolean;
  error: string | null;

  getSingleMatch: (matchId: number) => Promise<void>;

  // ❤️ normal priority
  updatePriority: (matchId: number, priority: number, column: string) => Promise<void>;

  // 💎 diamond action
  sendDiamond: (matchId: number) => Promise<void>;
}

export const useSingleMatchStore = create<SingleMatchState>((set, get) => ({
  match: null,
  loading: false,
  error: null,

  // --------------------------------------------------
  // 📥 GET SINGLE MATCH
  // --------------------------------------------------
  getSingleMatch: async (matchId) => {
    set({ loading: true, error: null });

    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) {
        set({ loading: false, error: "User not authenticated." });
        return;
      }

      const requestData = {
        id: Base64e.encode(user.id + ""),
        matchId: matchId,
        lat: user?.lat,
        lng: user?.lang,
      };

      const response = await axiosInstance.post("getSingleMatch", requestData);

      if (response.status === 200 && response.data) {
        set({ match: response.data, loading: false });
      } else {
        set({ error: "Match not found.", loading: false });
      }
    } catch (error) {
      console.error("Error fetching match:", error);
      set({ error: "Failed to fetch match.", loading: false });
    }
  },

  // --------------------------------------------------
  // ❤️ NORMAL PRIORITY UPDATE
  // --------------------------------------------------
  updatePriority: async (matchId, priority, column) => {
    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) return;

      const data = {
        from: Base64e.encode(user.id + ""),
        to: Base64e.encode(matchId + ""),
        priority: priority,
        column: column,
        status: 0,
        is_diamond: false,
      };

      await axiosInstance.post("sendUserRequests", data);

      get().getSingleMatch(matchId);

      console.log(`Priority updated for ${matchId}`);
    } catch (error) {
      console.error("Error updating priority:", error);
    }
  },

  // --------------------------------------------------
  // 💎 SEND DIAMOND
  // --------------------------------------------------
  sendDiamond: async (matchId) => {
    try {
      const authStore = useAuthStore.getState();
      const user = authStore.user;

      if (!user) return;

      const data = {
        from: Base64e.encode(user.id + ""),
        to: Base64e.encode(matchId + ""),
        priority: 100,
        column: "priority",
        status: 0,
        is_diamond: true,
      };

      set((state) => ({
        match: state.match
          ? { ...state.match, is_diamond: true }
          : state.match,
      }));

      // ✅ FIX: const res = hata diya — unused variable TS6133
      await axiosInstance.post("sendUserRequests", data);

      get().getSingleMatch(matchId);

      console.log("💎 Diamond sent successfully");
    } catch (error: any) {
      console.error("Diamond error:", error);

      set((state) => ({
        match: state.match
          ? { ...state.match, is_diamond: false }
          : state.match,
      }));
    }
  },
}));